import { Component, OnInit, NgZone } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { Vehicle } from "../../../models/vehicle";
import { MouseEvent, MapsAPILoader } from "@agm/core";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
var CryptoJS = require("crypto-js");
import { AppConstants } from "../../../constants/app-constants";

@Component({
  selector: "app-vehicle",
  templateUrl: "./vehicle.component.html",
  styleUrls: ["./vehicle.component.css"],
})
export class VehicleComponent implements OnInit {
  vhclForm: FormGroup;
  submitted: boolean = false;
  errorMessage: string;
  searchForm: any;
  disbaleUpdate: boolean = false;
  errorType: boolean = false;
  id: string = "";
  vhclMstLt: any[];
  name: string = '';
  vhclMst: Vehicle;
  editvehicle: Vehicle;
  displayValue: Number = 0;
  cabmaster: any;
  driverusers: any;
  driverSelectedItems: any[] = [this.id, this.name];
  formDriverSelectedItems: any[] = [];
  driverDropdownSettings = {};
  driver_id: any[] = [];
  geofence_limit: Number;
  positionHome: any;
  positionOffcie: any;
  user_Home_Address: string;
  user_id: string;
  user_name: string;
  user_Office_Address: any;
  vehicle_model: string;
  vehicle_no: string;
  agency_type: string;
  filterError: boolean;

  managerEmp: any;
  buttonValue: string;
  tempEditData: any = {};
  lat: number = 12.7369761;
  lng: number = 80.0066669;

  homelat: number = 12.73377;
  homelong: number = 80.011268;
  officelat: number = 12.73377;
  officelong: number = 80.011268;
  homeAddress: string = "-";
  officeAddress: string = "RNTBCI";
  offset = 0;
  limit = 100;
  homeMarker = {};
  officeMarker = {};
  markers = [];
  centerPosition = { lat: 12.73377, lng: 80.011268 };
  metaData: any[] = [];
  loader: number = 2;
  vhclMstLtData = [];

  formDriverDropdownSettings = {};

  constructor(
    public awserviceProvider: AwsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private formBuilder: FormBuilder
  ) {
    this.spinnerService.show();

    //getMetaData
    this.awserviceProvider.getMetaData().then((metadata) => {
      this.metaData = metadata;
      this.metaData = this.metaData.map((item) => {
        item.agency_types = [
          {
            type: 0,
            name: "All",
          },
          ...(item.agency_types || []),
        ];
        return item;
      });
    });


    // this.getAllData();

    //get Driver List
    // this.awserviceProvider.getRncUsersByType(3).then(driverusers => {
    //   this.driverusers = driverusers;
    // });

    //get Driver List
    let driverNextToken = "";
    this.awserviceProvider.getRncUsersByTypeByToken(3).then((driversresult) => {
      // Transform driver data to ensure user_name is a string
      this.driverusers = driversresult.map((driver) => {
        return {
          ...driver,
          user_name: (driver.user_name) 
            ? String(driver.user_name)
            : ''
        };
      }).filter((driver) => driver.user_name); // Filter out items with empty user_name

      this.syncFormDriverSelection(this.vhclForm ? this.vhclForm.get("driver_id").value : "");
      
      // driverNextToken = driversresult.nextToken;
      // //if (this.driverNextToken!=="") {
      // this.GetDriverNextToken(driverNextToken);
      // }
      this.spinnerService.hide();
    });
  }

  GetDriverNextToken(driverNextToken) {

    // if (this.offset != 0) {
    //get Driver List
    this.awserviceProvider
      .getRncUsersByTypeByNextToken(3)
      .then((driversresult) => {
        driverNextToken = "";
        this.driverusers = this.driverusers.concat(driversresult);
        //driverNextToken = driversresult.nextToken;
        // if (this.driverusers && this.driverusers.length === this.limit) {
        //   this.offset += this.limit;
        //   this.GetDriverNextToken(driverNextToken);
        // } else {
        //   this.offset = 0;
        //   this.spinnerService.hide();
        // }
        this.spinnerService.hide();
        // if (driverNextToken) {
        //   this.GetDriverNextToken(driverNextToken);
        // } else {
        //   this.spinnerService.hide();
        // }
      });
    // } else {
    //   this.spinnerService.hide();
    // }
  }

  decrypt(input) {
    let result =
      input == null
        ? ""
        : CryptoJS.AES.decrypt(
          input.toString(),
          AppConstants.cryptoKey
        ).toString(CryptoJS.enc.Utf8);
    return result;
  }

  getAllData() {
    this.vhclMstLt = [];
    let cnt = 0;
    this.awserviceProvider.getVehicleMaster().then((vehicleMs) => {
      this.dataFormation(vehicleMs);
    });
  }

  get f() {
    return this.vhclForm.controls;
  }

  async saveVehicleMaster() {
    if (this.buttonValue == "Save") {
      this.awserviceProvider
        .createVehicleMst(this.vhclForm.value)
        .then((res) => {
          this.displayValue = 0;
          this.getAllData();
        })
        .catch((err) => {
          this.errorType = true;
          this.errorMessage =
            "Unable to add the data. Please contact system administrator";
        });
    } else {
      this.awserviceProvider
        .updateVehicleMaster(this.vhclForm.value)
        .then((res) => {
          this.displayValue = 0;
          this.awserviceProvider.updatePersonalDriverAgency(
            this.vhclForm.value.driver_id,
            this.vhclForm.value.agency_type
          );
          console.log("FormValue::", this.searchForm);
          this.search(this.searchForm);
          //  this.getAllData();
        })
        .catch((err) => {
          this.errorType = true;
          console.log(err);
          this.errorMessage =
            "Unable to add the data. Please contact system administrator";
        });
    }
  }

  onSubmit() {
    // alert(this.vhclForm.invalid)
    this.submitted = true;

    if (this.vhclForm.invalid) {
      return;
    }
    this.disbaleUpdate = true;
    this.saveVehicleMaster();
  }

  // search(searchData) {
  //   searchData.driver_id = searchData.driver_id[0].id;
  //   this.searchForm = searchData;

  //   console.log("SEARCH_FORM_DATA", this.searchForm);
  //   console.log("searchData.agency_type", searchData.agency_type);
  //   if (searchData.agency_type == "" || searchData.agency_type == undefined) {
  //     this.filterError = true;
  //     return;
  //   }
  //   this.loader = 1;
  //   this.vhclMstLt = [];

  //   this.awserviceProvider.getVehicleMasterAll(searchData).then((vehicleMs) => {
  //     this.dataFormation(vehicleMs);
  //     this.loader = 2;
  //   });
  // }

  search(searchData) {
    searchData.driver_id = searchData.driver_id.map(function (driver) {
      if (driver && driver.id !== "" && driver.id !== undefined) {
        return driver.id;
      } else {
        return driver;
      }
    });
    this.searchForm = searchData;

    console.log("SEARCH_FORM_DATA", this.searchForm);
    console.log("searchData.agency_type", searchData.agency_type);
    if (searchData.agency_type == "" || searchData.agency_type == undefined) {
      this.filterError = true;
      return;
    }
    this.loader = 1;
    this.vhclMstLt = [];
    this.vhclMstLtData = [];

    this.awserviceProvider.getVehicleMasterAll(searchData).then((vehicleMs) => {
      this.dataFormation(vehicleMs.items);
      this.loader = 2;
    });
  }

  dataFormation(vehicleMs) {
    let cnt = 0;
    let vhclMstLt = vehicleMs;
    vhclMstLt.forEach((vhl) => {
      if (typeof vhl.home_address === 'string') {
        vhl.home_address = JSON.parse(vhl.home_address);
      }
      if (typeof vhl.office_address === 'string') {
        vhl.office_address = JSON.parse(vhl.office_address);
      }

      vhl.home_address.lat = vhl.home_address.elat
        ? this.decrypt(vhl.home_address.elat)
        : '';
      vhl.home_address.long = vhl.home_address.elong
        ? this.decrypt(vhl.home_address.elong)
        : '';
      vhl.home_address.address = vhl.home_address.address
        ? vhl.home_address.address
        : '';
      vhl.office_address.lat = vhl.office_address.elat
        ? this.decrypt(vhl.office_address.elat)
        : '';
      vhl.office_address.long = vhl.office_address.elong
        ? this.decrypt(vhl.office_address.elong)
        : '';
      vhl.office_address.address = vhl.office_address.address
        ? vhl.office_address.address
        : '';
      vhl.user_phone_number = this.decrypt(vhl.user_phone_number);
      vhl.cnt = cnt + 1;

      vhl.agency_type = this.metaData[0].agency_types.filter((element) => {
        if (element.type == vhl.agency_type) {
          return element.name;
        } else {
          return "";
        }
      });

      // this.awserviceProvider.getRncUsers(vhl.driver_id).then((driver) => {
      //   vhl.driver = driver;
      //   //console.log("vhl.agency_type[0]!=null?vhl.agency_type[0].type:",vhl.agency_type[0]!=null?vhl.agency_type[0].type:"");
      // });
      // this.awserviceProvider.getRncUsers(vhl.user_id).then((user) => {
      //   vhl.user = user;
      // });

      cnt++;
      this.vhclMstLt.push(vhl);
    });

    this.vhclMstLt.forEach((vehicle) => {
      if (!this.vhclMstLtData.some((item) => item.driver_id == vehicle.driver_id)) {
        let driverObj = {
          driver_name: vehicle.driver.name,
          driver_id: vehicle.driver_id,
          records: []
        }
        driverObj.records.push(vehicle);
        this.vhclMstLtData.push(driverObj);
      } else {
        const index = this.vhclMstLtData.findIndex((item) => item.driver_id == vehicle.driver_id);
        this.vhclMstLtData[index].records.push(vehicle);
      }
    });
    console.log(this.vhclMstLtData);

  }

  editData(vhclData) {
    this.buttonValue = "Update";
    this.displayValue = 1;
    this.disbaleUpdate = false;
    this.id = vhclData.id;

    console.log(vhclData.driver_id, "driver_id");

    this.syncFormDriverSelection(vhclData.driver_id);

    this.vhclForm.setValue({
      id: vhclData.id,
      driver_id: vhclData.driver_id,
      vehicle_no: vhclData.vehicle_no,
      vehicle_model: vhclData.vehicle_model,
      geofence_limit: vhclData.geofence_limit,
      user_id: vhclData.user_id,
      user_name: vhclData.user_name,
      user_phone_number: vhclData.user_phone_number,
      agency_type:
        vhclData.agency_type[0] != null ? vhclData.agency_type[0].type : "",
      notification_flag: vhclData.notification_flag,
      home_lat: vhclData.home_address.lat,
      home_long: vhclData.home_address.long,
      home_address: vhclData.home_address &&
        vhclData.home_address.address
        ? vhclData.home_address.address
        : '',
      office_lat: vhclData.office_address.lat,
      office_long: vhclData.office_address.long,
      office_address: vhclData.office_address &&
        vhclData.office_address.address
        ? vhclData.office_address.address
        : '',
    });
  }

  setName(name) {
    this.user_name = name;
    // alert(name);
  }

  deleteData(vhcl) {
    this.awserviceProvider
      .deleteDaVehicleMaster(vhcl.id)
      .then((res) => {
        // this.getAllData();
        this.search(this.searchForm);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  add() {
    this.formInitilization();
    this.buttonValue = "Save";
    this.displayValue = 1;
  }

  exportToExcel() {
    let exportJsonTemp = [];
    exportJsonTemp = this.exportJsonFormation(this.vhclMstLt);

    exportJsonTemp = exportJsonTemp.map((item) => {
      delete item.driver_id;
      return item;
    });

    // Modify exportJsonTemp to handle grouping by 'driver'
    // let groupedData = [];

    // exportJsonTemp.forEach(item => {
    //   if (!groupedData.some((driverObj) => driverObj.driver_id == item.driver_id)) {
    //     let obj = { driver: item.driver, employee_phone: item.employee_phone, isGroup: true, records: [] }
    //     // If the driver changes, add a row for the driver as a header group
    //     delete item.driver;
    //     delete item.driver_id;
    //     delete item.employee_phone;
    //     obj.records.push(item);
    //     groupedData.push(obj); // Group header row
    //   } else {
    //     const index = groupedData.findIndex((driverObj) => driverObj.driver_id == item.driver_id)
    //     // Add the normal data row
    //     delete item.driver;
    //     delete item.driver_id;
    //     delete item.employee_phone;
    //     groupedData[index].records.push(item);
    //   }
    // });

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "Data");
    // for(let item of  groupedData) {
    //   const driverName = item.driver;
    //   const driverPhone = item.employee_phone;
    //   let sheetName = `${driverName} - ${driverPhone}`;
    //   if (sheetName.length > 31) {
    //     sheetName = sheetName.substring(0, 31); // Truncate to 31 characters
    //   }

    //   const workSheet = XLSX.utils.json_to_sheet(item.records);
    //   XLSX.utils.book_append_sheet(workBook, workSheet, sheetName); // add the worksheet to the book
    // }


    XLSX.writeFile(workBook, "DA_PERSONAL_DRIVERS.xlsx");
  }

  // exportToPdf() {
  //   var getColumns = [
  //     { title: "Driver", dataKey: "driver" },
  //     { title: "Vehicle", dataKey: "vehicle_no" },
  //     { title: "Model", dataKey: "vehicle_model" },
  //     { title: "Agency", dataKey: "agency_type" },
  //     { title: "User ID", dataKey: "user_id" },
  //     { title: "User Name", dataKey: "user_name" },
  //     { title: "User Phone No", dataKey: "user_phone_number" },
  //     { title: "Notification", dataKey: "notification_flag" },
  //     { title: "Geofence Limit", dataKey: "geofence_limit" },
  //     { title: "Home Address", dataKey: "home_address" },
  //     { title: "Office Address", dataKey: "office_address" },
  //   ];

  //   var pdfsize = "a4";
  //   var doc = new jsPDF("l", "pt", pdfsize);

  //   doc.text(20, 20, "Driver Attendance");
  //   let exportJsonTemp = [];
  //   exportJsonTemp = this.exportJsonFormation(this.vhclMstLt);
  //   doc.autoTable(getColumns, exportJsonTemp, {
  //     startY: 40,
  //     // startX: 20,
  //     tableLineColor: [189, 195, 199],
  //     tableLineWidth: 0.75,
  //     styles: {
  //       font: "Times New Roman",
  //       fillColor: [217, 217, 217],
  //       lineColor: [189, 195, 199],
  //       lineWidth: 0.25,
  //       textColor: 0,
  //     },
  //     headerStyles: {
  //       fillColor: [217, 217, 217],
  //       textColor: 0,
  //       overflow: "linebreak",
  //     },
  //     columnStyles: {
  //       text: { overflow: "linebreak" },
  //       home_address: { cellWidth: 120, overflow: "linebreak" },
  //       office_address: { cellWidth: 120, overflow: "linebreak" },
  //       user_name: { cellWidth: 120, overflow: "linebreak" },
  //       // user_phone_number: {cellWidth: 120,overflow: 'linebreak'},
  //       driver: { cellWidth: 80, overflow: "linebreak" },
  //       geofence_limit: { cellWidth: 30, overflow: "linebreak" },
  //     },
  //   });
  //   doc.save("DA_PERSONAL_DRIVERS.pdf");
  // }

  exportToPdf() {
    var getColumns = [
      { title: "Driver Phone", dataKey: "driver_phone" },
      { title: "Vehicle", dataKey: "vehicle_no" },
      { title: "Model", dataKey: "vehicle_model" },
      { title: "Agency", dataKey: "agency_type" },
      { title: "User ID", dataKey: "user_id" },
      { title: "User Name", dataKey: "user_name" },
      { title: "User Phone No", dataKey: "user_phone_number" },
      { title: "Notification", dataKey: "notification_flag" },
      { title: "Geofence Limit", dataKey: "geofence_limit" },
      { title: "Home Address", dataKey: "home_address" },
      { title: "Office Address", dataKey: "office_address" }
    ];

    var doc = new jsPDF("l", "pt", "a4");

    // Grouping logic (safe)
    var exportJsonTemp = this.exportJsonFormation(this.vhclMstLt) || [];
    var groupedData = [];

    for (var i = 0; i < exportJsonTemp.length; i++) {
      var item = exportJsonTemp[i];
      var foundIndex = -1;
      for (var g = 0; g < groupedData.length; g++) {
        if (groupedData[g].driver_id === item.driver_id) {
          foundIndex = g;
          break;
        }
      }
      if (foundIndex === -1) {
        groupedData.push({ driver_id: item.driver_id, driver: item.driver, records: [item] });
      } else {
        groupedData[foundIndex].records.push(item);
      }
    }

    var groupedPdfRecord = [];
    for (var gi = 0; gi < groupedData.length; gi++) {
      var grp = groupedData[gi];
      groupedPdfRecord.push({ driver: grp.driver, isGroup: true });
      for (var r = 0; r < grp.records.length; r++) {
        groupedPdfRecord.push(grp.records[r]);
      }
    }

    doc.text("Driver Attendance", 20, 20);

    // Prepare head and body for autoTable (compatible format)
    var headRow = getColumns.map(function (c) { return c.title; });
    var bodyRows = [];
    for (var bi = 0; bi < groupedPdfRecord.length; bi++) {
      var row = groupedPdfRecord[bi];
      var rowArr = [];
      for (var ci = 0; ci < getColumns.length; ci++) {
        var key = getColumns[ci].dataKey;
        // If row doesn't have that key (e.g., group row), push empty or group text in first column
        if (row && row.hasOwnProperty(key)) {
          rowArr.push(row[key]);
        } else if (row && row.isGroup && ci === 0) {
          rowArr.push(row.driver || "");
        } else {
          rowArr.push("");
        }
      }
      bodyRows.push(rowArr);
    }
    doc.autoTable({
      columns: getColumns,
      body: groupedPdfRecord,
      tableLineColor: [189, 195, 199],
      styles: {
        lineWidth: 0.1,
        fontSize: 8,
        fillColor: [217, 217, 217],
        lineColor: [189, 195, 199],
        textColor: 0,
      },

      headStyles: {
        fillColor: [217, 217, 217],
        textColor: 0,
        fontStyle: 'bold'
      },

      bodyStyles: {
        fillColor: [217, 217, 217]
      },

      columnStyles: {
        userId: {
          cellWidth: 40,
          overflow: 'linebreak'
        },
        text: { overflow: "linebreak" },
        driver_phone: { cellWidth: 80, overflow: "linebreak" },
        home_address: { cellWidth: 120, overflow: "linebreak" },
        office_address: { cellWidth: 120, overflow: "linebreak" },
        user_name: { cellWidth: 120, overflow: "linebreak" },
        geofence_limit: { cellWidth: 30, overflow: "linebreak" },
      },

      didParseCell(data) {
        const raw = data.row.raw;

        // --- GROUP ROW (Driver Name) ---
        if (raw && raw.isGroup) {

          // Only merge in first column
          if (data.column.index === 0) {

            // Merge across all columns
            data.cell.colSpan = getColumns.length;
            // Text
            data.cell.text = raw.driver || "";
            // Bold + no borders + white background
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [255, 255, 255];
            // data.cell.styles.lineWidth = 0;
            // data.cell.styles.vlineWidth = 0;
            // data.cell.styles.hlineWidth = 0;
            data.cell.styles.overflow = 'hidden';
          }
          else {
            // Hide all other cells
            data.cell.colSpan = 0;
            data.cell.text = "";
          }
          data.cell.styles.hlineWidth = 0.1;   // top/bottom border
          data.cell.styles.vlineWidth = 0.1;   // left/right border
          data.cell.styles.lineColor = [189, 195, 199];  // solid black border
        }
      }
    });

    doc.save("DA_PERSONAL_DRIVERS.pdf");
  }

  exportJsonFormation(vechiles) {
    let exportJsonTemp = [];

    vechiles.forEach((vhcl) => {
      let exJson: any = {};

      exJson.driver = vhcl.driver != null ? vhcl.driver.name : "";
      exJson.driver_id = vhcl.driver_id;
      exJson.driver_phone = vhcl.driver.employee_phone;
      exJson.vehicle_no = vhcl.vehicle_no;
      exJson.vehicle_model = vhcl.vehicle_model;
      exJson.user_id = vhcl.user_id;
      exJson.user_name = vhcl.user_name;
      exJson.geofence_limit = vhcl.geofence_limit;
      exJson.user_phone_number = vhcl.user_phone_number;
      exJson.notification_flag = vhcl.notification_flag == 1 ? "ON" : "OFF";
      exJson.agency_type =
        vhcl.agency_type.length > 0 ? vhcl.agency_type[0].name : "";
      exJson.home_lat = vhcl.home_address != null ? vhcl.home_address.lat : "";
      exJson.home_long =
        vhcl.office_address != null ? vhcl.home_address.long : "";
      exJson.office_lat =
        vhcl.home_address != null ? vhcl.office_address.lat : "";
      exJson.office_long =
        vhcl.office_address != null ? vhcl.office_address.long : "";
      exJson.home_address =
        vhcl.home_address != null ? vhcl.home_address.address : "";
      exJson.office_address =
        vhcl.office_address != null ? vhcl.office_address.address : "";
      exportJsonTemp.push(exJson);
    });

    return exportJsonTemp;
  }

  ngOnInit() {
    // this.editvehicle={};
    this.filterError = false;
    this.buttonValue = "";
    this.displayValue = 0;
    this.driver_id = [];
    this.vehicle_no = "";
    this.user_name = "";
    this.vhclMstLt = [];
    this.loader = 3;
    // this.driverDropdownSettings = {
    //   singleSelection: true,
    //   idField: "id",
    //   textField: "id",
    //   itemsShowLimit: 5,
    //   allowSearchFilter: true,
    // };

    this.driverDropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "user_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.formDriverDropdownSettings = {
      singleSelection: true,
      idField: "id",
      textField: "user_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.formInitilization();
  }

  onFormItemSelect(item: any) {
    console.log("onItemSelect", item);
    this.formDriverSelectedItems = [item];
    this.vhclForm.patchValue({ driver_id: item.id });
    console.log(this.vhclForm.get('driver_id').value);
  }

  onFormItemDeSelect(item: any) {
    console.log("onDeSelect", item);
    this.formDriverSelectedItems = [];
    this.vhclForm.patchValue({ driver_id: "" });
    console.log(this.vhclForm.get('driver_id').value);
  }

  syncFormDriverSelection(driverId: any) {
    if (!driverId || !this.driverusers) {
      this.formDriverSelectedItems = [];
      return;
    }
    this.formDriverSelectedItems = this.driverusers.filter((driver) => driver.id === driverId);
  }

  onFormDeSelectAll(items: any) {
    console.log("onDeSelectAll", items);
    this.formDriverSelectedItems = [];
    this.vhclForm.patchValue({ driver_id: "" });
    console.log(this.vhclForm.get('driver_id').value);
  }


  formInitilization() {
    this.vhclForm = new FormGroup({
      id: new FormControl(),
      driver_id: new FormControl("", Validators.required),
      vehicle_no: new FormControl("", Validators.required),
      vehicle_model: new FormControl("", Validators.required),
      geofence_limit: new FormControl("", Validators.required),
      agency_type: new FormControl("", Validators.required),
      user_phone_number: new FormControl(),
      notification_flag: new FormControl(),
      user_id: new FormControl("", Validators.required),
      user_name: new FormControl("", Validators.required),
      home_lat: new FormControl(12.737693),
      home_long: new FormControl(80.006663),
      home_address: new FormControl("", Validators.required),
      office_lat: new FormControl(12.737693),
      office_long: new FormControl(80.006663),
      office_address: new FormControl("", Validators.required),
    });
    this.formDriverSelectedItems = [];
  }
}

// getGeoAddress(lat, lng): Promise<any> {
//   let myPromise = new Promise((resolve, reject) => {
//     // setTimeout(() => {
//     let geocoder = new google.maps.Geocoder();
//     // var lat = parseFloat(position.lat);
//     // var lng = parseFloat(position.long);
//     var latlng = new google.maps.LatLng(lat, lng);

//     geocoder.geocode({ 'latLng': latlng }, function (results, status) {
//       if (status == google.maps.GeocoderStatus.OK) {
//         if (results[1]) {
//           var address = results[1].formatted_address;
//           resolve(address)
//         } else if (status == "ZERO_RESULTS") {

//           return "-"
//         }
//         else if (status == "REQUEST_DENIED") {
//           return "-"
//         }

//       } else {
//         reject(status)

//       }
//     });

//   })
//   return myPromise
// }

// upload() {
//   let la = CryptoJS.AES.encrypt("12.0003", AppConstants.cryptoKey);
//   let l = CryptoJS.AES.decrypt(la.toString(), AppConstants.cryptoKey).toString(CryptoJS.enc.Utf8);
//   this.vhclMstLt = [];
//   this.awserviceProvider.getVehicleMaster().then(vehicleMs => {
//     let vhclMstLt = vehicleMs;
//     var i = 0;
//     vhclMstLt.forEach(vhl => {
//       if (vhl.home_address.lat > 0) {

//  let hlat = vhl.home_address.lat.toString();
//  let hlong =vhl.home_address.long.toString();
//  let lat =  vhl.office_address.lat.toString();
//  let long = vhl.office_address.long.toString();

//  let ohlat =  CryptoJS.AES.encrypt(hlat, AppConstants.cryptoKey).toString();
//  let ohlong = CryptoJS.AES.encrypt(hlong, AppConstants.cryptoKey).toString();
//  let olat =   CryptoJS.AES.encrypt(lat, AppConstants.cryptoKey).toString();
//  let olong =  CryptoJS.AES.encrypt(long, AppConstants.cryptoKey).toString();
// //let phone = CryptoJS.AES.encrypt(AppConstants.defaultPassword, AppConstants.cryptoKey).toString();

// this.awserviceProvider.encryptLatLong(vhl.id,ohlat,ohlong,olat,olong).then(id => {

// })

// }
// else {
//   console.log("else", vhl.home_address.lat);
// }

//   if(vhl.user_phone_number!=null)  {
//     let ph =  CryptoJS.AES.encrypt(vhl.user_phone_number, AppConstants.cryptoKey).toString();
//     this.awserviceProvider.encryptLatLong(vhl.id,ph).then(id => {

//      console.log("UODATED",id)

//     })
// console.log("USRE",vhl.user_phone_number)
//   }

//     })

//   });
// }

//   uploadAgncy(){
//     var id="12";
//     var agency_type="1"
//     var user_name="RN00693"
// var datainput =
// [

// ];

// datainput.forEach(data => {

//   console.log("data.vehicle_no",data.vehicle_no)
//   console.log("data.user_id",data.user_id)
//   var vehicle : any={}=this.vhclMstLt.filter((element) => {
//     if (element.vehicle_no == data.vehicle_no) {
//       return element.id
//     } else {
//       return ""
//     }
//   })
//   if(vehicle.length>0){
//       this.awserviceProvider.updateVehicleMstAgency(data.user_id,vehicle[0].id,"2").then(res=>{

//         console.log("res",res)
//       })
//     }
//     else {
//       console.log("unabel to update",data);
//     }

// });

//   }

// async findAddress($event, val) {
//   if (val == 1) {
//     this.vhclForm.patchValue({ home_lat: $event.coords.lat });
//     this.vhclForm.patchValue({ home_lng: $event.coords.lng });
//   }
//   else {
//     this.vhclForm.patchValue({ office_lat: $event.coords.lat });
//     this.vhclForm.patchValue({ office_lng: $event.coords.lng });
//   }
//   await this.getGeoAddress(this.homelat, this.homelong).then(response => {
//     if (val == 1) { this.vhclForm.patchValue({ home_address: response }); }
//     else { this.vhclForm.patchValue({ office_address: response }); }
//   }).catch(err => {
//     console.log(err);
//   })
// }
